import Model from 'core/model/Model';

export default class CompanyMessageModel extends Model {
  get urlRoot() {
    return this.collection?.url || '/api/ui/sudo/messages';
  }
}
